import logger from "../../../utils/logger";
import { loadLocations, loadLocationsSuccess } from "../reducer/locations";
import * as uiActions from "../reducer/ui";

const loadLocationsFlow = ({ getLocationList }) => ({ dispatch, getState }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === loadLocations.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getLocationList();
      dispatch(loadLocationsSuccess(Object.values(response.data.data)));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const locationsFlow = [loadLocationsFlow];

export default locationsFlow;
